import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDTypography from "common/components/MD/MDTypography";

import CardGiftcardRoundedIcon from '@mui/icons-material/CardGiftcardRounded';
import LocalAtmRoundedIcon from '@mui/icons-material/LocalAtmRounded';
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import InvitiService from "services/API/Inviti/InvitiService";
import InvitiTable from "./InvitiTable";
import MDBadge from "common/components/MD/MDBadge/MDBadge";
import MDButton from "common/components/MD/MDButton";
import DataTable from "common/components/implemented/Tables/DataTable/DataTables";

function InvitiList({ idRichiesta,tipo,refresh,elimina_invito,invia_invito,stampa_invito,filtra,prima_di_filtrare }) {



  const [lista_inviti, setLista_inviti] = useState([]);


  useEffect(() => {
console.log("carica");
if(refresh){
 setLista_inviti([]); // svuota prima del reload
    carica();}
  }, [idRichiesta,tipo,refresh]);

  function carica() {
    InvitiService.getMyInviti(idRichiesta,tipo)
      .then(response => {
        //console.log(response.data);
        setLista_inviti(response.data);
      })
      .catch(e => {
        console.log(e);
      });

  }
  // Memoizza la lista degli inviti per stabilità
  const ppAttributes = useMemo(() => {
    if (!lista_inviti || lista_inviti.length === 0) return [];

    return lista_inviti.map(invito => {
      const cn = `${invito.cognome} ${invito.nome}`;
let color=(tipo==="IO"?"primary":(tipo==="IR"?"info":(tipo==="PE"?"warning":"success")));

      const action_invia = (
        <MDBox>
          <MDButton variant="text" color={color} iconOnly onClick={() => invia_invito(invito.idInvito)}>
            <Icon>send</Icon>
          </MDButton>
        </MDBox>
      );

      const action_stampa = (
        <MDBox>
          <MDButton variant="text" color={color} iconOnly onClick={() => stampa_invito(invito.idInvito)}>
            <Icon>print</Icon>
          </MDButton>
        </MDBox>
      );

      const action_del = (
        <MDBox>
          {!invito.codice &&
          <MDButton variant="text" color={color} iconOnly onClick={() => elimina_invito(invito.idInvito)}>
            <Icon>delete</Icon>
          </MDButton>
    }
        </MDBox>
      );

      const tipologia = invito.tipo_dot === "IO" ? (
        <MDBox>
          <CardGiftcardRoundedIcon color="primary" /> Omaggio
        </MDBox>
      ) : (tipo==="IR"?(
        <MDBox>
          <LocalAtmRoundedIcon color="info" /> Ridotto
        </MDBox>
      ):(tipo==="PE"?(
        <MDBox>
          <EngineeringRoundedIcon color="warning" /> Pass Espositore
        </MDBox>
      ):""));
  let badge = <MDBadge badgeContent="Da Inviare" size="xs" variant="gradient" color="warning" container />;
      if(invito.codice!=null){
  badge = <MDBadge badgeContent="Inviato" size="xs" variant="gradient" color="success" container />;
      }
    

      return {
        invito,
        idInvito: invito.idInvito,
        id_richiesta: invito.id_richiesta,
        azienda: invito.azienda,
        tipo_dot: invito.tipo_dot,
        tipologia,
        cognome_nome: cn,
        email: invito.email,
        stato: badge,
        codice: invito.codice,
        data_invio: invito.string_data_invio,
        icona_invia: action_invia,
        icona_stampa: action_stampa,
        icona_elimina: action_del,
      };
    });
  }, [lista_inviti]);

  // Memoizza anche i dati della tabella
  const ppTableData = useMemo(() => ({
    rows: ppAttributes,

    columns: [
      { Header: "Tipologia", accessor: "tipologia", align: "left", with: "10%", id: "li_0" },
      { Header: "Ragione Sociale", accessor: "azienda", align: "left", with: "15%", id: "li_1" },
      { Header: "Nome", accessor: "cognome_nome", align: "left", width: "15%", id: "li_2" },
      { Header: "Email", accessor: "email", align: "left", width: "15%", id: "li_3"},
      { Header: "Stato", accessor: "stato", align: "left", width: "10%", id: "li_4" },
      { Header: "Codice", accessor: "codice", align: "left", width: "10%", id: "li_5" },
      { Header: "Data Invio", accessor: "data_invio", align: "left", width: "10%", id: "li_6" },
      { Header: "Invia", accessor: "icona_invia", width: "5%", align: "left", id: "li_7" },
      { Header: "Stampa", accessor: "icona_stampa", width: "5%", align: "left", id: "li_8" },
      { Header: "Elimina", accessor: "icona_elimina", width: "5%", align: "left", id: "li_9" },


    ],



  }),[lista_inviti]);

  let mycolor=(tipo==="IO"?"primary":(tipo==="IR"?"info":(tipo==="PE"?"warning":"success")));

  const mypagination = { color:{mycolor}, variant: "contained" };




  return (

    <Card sx={{ height: "100%", boxShadow: true && "none", mx: 10 }}>

      {(lista_inviti != null || lista_inviti.length > 0) &&
        <MDBox >
          <MDBox pt={2} px={2}>
            <MDTypography color='text' fontWeight='medium' sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}>
              &nbsp;&nbsp;Lista Invio&nbsp;
            </MDTypography>
          </MDBox>
          <MDBox pt={3}>
      <InvitiTable
              canSearch={false}
              table={ppTableData}
              nome_tabella={"inviti_espositore_"+tipo}
              isSorted={true}
              entriesPerPage={true}
              showTotalEntries={true}
              pagination={mypagination}
              noEndBorder
              responsive={true}
              enableColumnFilters={false}
              chiamante='inviti_list'
              tipo={tipo}
           filtra={filtra}
           prima_di_filtrare={prima_di_filtrare}
            />
          </MDBox>


        </MDBox>
      }
      {(lista_inviti == null || lista_inviti.length === 0) &&
        <MDBox style={{ height: "200px" }} textAlign='center'>
          <MDTypography
            variant="button"
            fontWeight="regular"
            color="text"
            sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
          >
            Non ci sono Inviti nella tua lista di invio.
          </MDTypography></MDBox>
      }
    </Card>




  );
}



export default InvitiList;
